import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";

export const seismicZoneLegendPerLevel = (t, zone) => {
  return (
    `${t("riskAssessment.Zone")} ${zone} : ` +
    [
      `${t("levels.noData")}`,
      `${t("levels.major")} (pga > 0.25)`,
      `${t("levels.strong")} (0.15 < pga ≤ 0.25)`,
      `${t("levels.medium")} (0.05 < pga ≤ 0.15)`,
      `${t("levels.low")} (pga < 0.05)`,
    ][zone]
  );
};

export const SeismicClassificationITALegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("riskAssessment.seismicClassification")} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#d63031")}></span>

        {seismicZoneLegendPerLevel(t, 1)}
      </div>
      <div>
        <span style={legendItemStyle("#fdcb6e")}></span>
        {seismicZoneLegendPerLevel(t, 2)}
      </div>
      <div>
        <span style={legendItemStyle("#00b894")}></span>
        {seismicZoneLegendPerLevel(t, 3)}
      </div>
      <div>
        <span style={legendItemStyle("#0984e3")}></span>
        {seismicZoneLegendPerLevel(t, 4)}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pga = {t("riskAssessment.pga")}  m/s<sup>2</sup>)
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from Dipartimento della Protezione Civile (version 31/03/2023) processed by
          CyStellar
        </span>
      </div>
    </div>
  );
};
